import { ClientBusinessUserFormType } from './ClientBusinessUserFormType';

export const createClientBusinessUserFormInitialValues =
  (): ClientBusinessUserFormType => ({
    email: '',
    name: '',
    is_admin: false
  });
